module.exports = {
	"ha": "iha",
	"id": 5.5,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by Age Category and MSM Status, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 72.72727272727273,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#043f61"
					},
					{
						"y": 63.63636363636363,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0c4250"
					},
					{
						"y": 63.63636363636363,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0d4440"
					},
					{
						"y": 45.45454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#09472e"
					},
					{
						"y": 18.181818181818183,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#043f61"
					},
					{
						"y": 96.29629629629629,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#0c4250"
					},
					{
						"y": 92.5925925925926,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.77777777777779,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#09472e"
					},
					{
						"y": 62.96296296296296,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "40"
						},
						"color": "#043f61"
					},
					{
						"y": 95,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#0c4250"
					},
					{
						"y": 95,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#0d4440"
					},
					{
						"y": 92.5,
						"dataLabels": {
							"enabled": false,
							"format": "37"
						},
						"color": "#09472e"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.7012987012987,
						"dataLabels": {
							"enabled": false,
							"format": "152"
						},
						"color": "#043f61"
					},
					{
						"y": 96.75324675324676,
						"dataLabels": {
							"enabled": false,
							"format": "149"
						},
						"color": "#0c4250"
					},
					{
						"y": 96.1038961038961,
						"dataLabels": {
							"enabled": false,
							"format": "148"
						},
						"color": "#0d4440"
					},
					{
						"y": 90.25974025974025,
						"dataLabels": {
							"enabled": false,
							"format": "139"
						},
						"color": "#09472e"
					},
					{
						"y": 65.5844155844156,
						"dataLabels": {
							"enabled": false,
							"format": "101"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0c4250"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0d4440"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#09472e"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.23809523809523,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#043f61"
					},
					{
						"y": 76.19047619047619,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.19047619047619,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0d4440"
					},
					{
						"y": 52.38095238095239,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#09472e"
					},
					{
						"y": 38.095238095238095,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.87234042553192,
						"dataLabels": {
							"enabled": false,
							"format": "46"
						},
						"color": "#043f61"
					},
					{
						"y": 93.61702127659575,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#0c4250"
					},
					{
						"y": 93.61702127659575,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.85106382978722,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#09472e"
					},
					{
						"y": 42.5531914893617,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "145"
						},
						"color": "#043f61"
					},
					{
						"y": 93.79310344827586,
						"dataLabels": {
							"enabled": false,
							"format": "136"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.72413793103448,
						"dataLabels": {
							"enabled": false,
							"format": "133"
						},
						"color": "#0d4440"
					},
					{
						"y": 82.06896551724138,
						"dataLabels": {
							"enabled": false,
							"format": "119"
						},
						"color": "#09472e"
					},
					{
						"y": 52.41379310344828,
						"dataLabels": {
							"enabled": false,
							"format": "76"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#043f61"
					},
					{
						"y": 46.666666666666664,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0c4250"
					},
					{
						"y": 46.666666666666664,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0d4440"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#09472e"
					},
					{
						"y": 26.666666666666668,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#043f61"
					},
					{
						"y": 94.73684210526315,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#0c4250"
					},
					{
						"y": 94.73684210526315,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#0d4440"
					},
					{
						"y": 84.21052631578947,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#09472e"
					},
					{
						"y": 52.63157894736842,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.5,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#043f61"
					},
					{
						"y": 82.5,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.5,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#0d4440"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#09472e"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.35036496350365,
						"dataLabels": {
							"enabled": false,
							"format": "132"
						},
						"color": "#043f61"
					},
					{
						"y": 80.2919708029197,
						"dataLabels": {
							"enabled": false,
							"format": "110"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.2919708029197,
						"dataLabels": {
							"enabled": false,
							"format": "110"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.64233576642336,
						"dataLabels": {
							"enabled": false,
							"format": "105"
						},
						"color": "#09472e"
					},
					{
						"y": 53.284671532846716,
						"dataLabels": {
							"enabled": false,
							"format": "73"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -60,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.703703703703709,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.8461538461538436,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.047619047619047,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.631578947368418,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.13513513513513,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.2987012987012991,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.9736842105263164,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -0.6711409395973145,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.081081081081086,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.338129496402875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.761904761904767,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.127659574468088,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.347826086956519,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.636363636363635,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -47.36842105263158,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.206896551724139,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.2058823529411797,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.526315789473683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -36.13445378151261,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -26.66666666666667,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -36.36363636363637,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.500000000000002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.384615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -46.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.649635036496346,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.545454545454541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.476190476190478,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=11"
			},
			{
				"x": 9,
				"text": "30-39<br>n=27"
			},
			{
				"x": 15,
				"text": "40-49<br>n=40"
			},
			{
				"x": 21,
				"text": ">=50<br>n=154"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=3"
			},
			{
				"x": 34,
				"text": "30-39<br>n=21"
			},
			{
				"x": 40,
				"text": "40-49<br>n=47"
			},
			{
				"x": 46,
				"text": ">=50<br>n=145"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=15"
			},
			{
				"x": 59,
				"text": "30-39<br>n=19"
			},
			{
				"x": 65,
				"text": "40-49<br>n=40"
			},
			{
				"x": 71,
				"text": ">=50<br>n=137"
			}
		],
		"dataTable": {
			"MSM:<30": [
				11,
				8,
				7,
				7,
				5,
				2
			],
			"MSM:30-39": [
				27,
				27,
				26,
				25,
				21,
				17
			],
			"MSM:40-49": [
				40,
				40,
				38,
				38,
				37,
				24
			],
			"MSM:>=50": [
				154,
				152,
				149,
				148,
				139,
				101
			],
			"Non-MSM:<30": [
				3,
				3,
				3,
				3,
				3,
				2
			],
			"Non-MSM:30-39": [
				21,
				20,
				16,
				16,
				11,
				8
			],
			"Non-MSM:40-49": [
				47,
				46,
				44,
				44,
				38,
				20
			],
			"Non-MSM:>=50": [
				145,
				145,
				136,
				133,
				119,
				76
			],
			"Unknown:<30": [
				15,
				11,
				7,
				7,
				6,
				4
			],
			"Unknown:30-39": [
				19,
				19,
				18,
				18,
				16,
				10
			],
			"Unknown:40-49": [
				40,
				39,
				33,
				33,
				30,
				16
			],
			"Unknown:>=50": [
				137,
				132,
				110,
				110,
				105,
				73
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_5.json
// module id = 238
// module chunks = 0